
  export const recipes = [
    {
      "dish_img": "https://www.kindmeal.my/photos/recipe/116/116077-17984-m.jpg",
      "dish_name": "Ras-El-Hanout (Moroccan Spice Blend)",
      "owner_name": "KindMealChef",
      "owner_img": "https://www.kindmeal.my/photos/member/0/6-m.jpg",
      "time": "5 Mins",
      "servings": "Depends",
      "restriction": "- - -",
      "rating": "★ ★ ★ ★ ★",
      "vote" : 6,
      "ingredients": [
        "1 1/4 teaspoons ground allspice",
        "2 teaspoons ground nutmeg",
        " 20 spanish saffron threads",
        "1 1/2 teaspoons ground black pepper",
        "1 1/2 teaspoons ground mace",
        "1 teaspoon ground cinnamon",
        "1 1/2 teaspoons ground cardamom",
        "2 teaspoons ground ginger",
        " 2 teaspoons salt",
        "1 teaspoon ground turmeric"
      ],
      "discription": "Using a mortar and pestle or a spice grinder, reduce the ingredients to a fine powder. Sift to remove fibrous elements. Place in a tightly sealed container and store in a cool, dark place, or in the freezer."
    },
    {
        "dish_img": "https://www.kindmeal.my/photos/recipe/1000/1000009-19416-m.jpg",
        "dish_name": "Vegetarian VFC",
        "owner_name": "MayNg",
        "owner_img": "https://www.kindmeal.my/photos/member/14/14169-m.jpg",
        "time": "1 Hr",
        "servings": "Depends",
        "restriction": "- - -",
        "rating": "★ ★ ★ ★ ",
        "vote" : 6,
        "ingredients": [
          "1 1/4 teaspoons ground allspice",
          "2 teaspoons ground nutmeg",
          " 20 spanish saffron threads",
          "1 1/2 teaspoons ground black pepper",
          "1 1/2 teaspoons ground mace",
          "1 teaspoon ground cinnamon",
          "1 1/2 teaspoons ground cardamom",
          "2 teaspoons ground ginger",
          " 2 teaspoons salt",
          "1 teaspoon ground turmeric"
        ],
        "discription": "This is the Vegetarian VFC that I created. Idea sourced from KFC."
      },
      {
        "dish_img": "https://www.kindmeal.my/photos/recipe/108/108760-16499-m.jpg",
        "dish_name": "Pears With Maple, Walnuts And Gorgonzola",
        "owner_name": "KindMealChef",
        "owner_img": "https://www.kindmeal.my/photos/member/14/14169-m.jpg",
        "time": "20 Mins",
        "servings": "Depends",
        "restriction": "- - -",
        "rating": "★ ★ ★ ★ ",
        "vote" : 6,
        "ingredients": [
          "1 1/4 teaspoons ground allspice",
          "2 teaspoons ground nutmeg",
          " 20 spanish saffron threads",
          "1 1/2 teaspoons ground black pepper",
          "1 1/2 teaspoons ground mace",
          "1 teaspoon ground cinnamon",
          "1 1/2 teaspoons ground cardamom",
          "2 teaspoons ground ginger",
          " 2 teaspoons salt",
          "1 teaspoon ground turmeric"
        ],
        "discription": "This is the Vegetarian VFC that I created. Idea sourced from KFC."
      },
      {
        "dish_img": "https://www.kindmeal.my/photos/recipe/108/108760-16499-m.jpg",
        "dish_name": "Hot Caramel Jam Recipe",
        "owner_name": "BurhanBohra",
        "owner_img": "https://www.kindmeal.my/photos/member/14/14169-m.jpg",
        "time": "15 Mins",
        "servings": "1 Cup",
        "restriction": "- - -",
        "rating": "★ ★ ★ ★ ",
        "vote" : 6,
        "ingredients": [
          "1 1/4 teaspoons ground allspice",
          "2 teaspoons ground nutmeg",
          " 20 spanish saffron threads",
          "1 1/2 teaspoons ground black pepper",
          "1 1/2 teaspoons ground mace",
          "1 teaspoon ground cinnamon",
          "1 1/2 teaspoons ground cardamom",
          "2 teaspoons ground ginger",
          " 2 teaspoons salt",
          "1 teaspoon ground turmeric"
        ],
        "discription": "Delicious hot Caramel Jam coffee. Try this delicious flavour of hot caramel coffee recipe. I tried this one to relax and change my mood and its awesome. I gave this unique name to my coffee as i always do with my all recipes.https://burhanrecipe. blogspot.com/2019/11/hot-caram el-coffee-aura.html."
      },
      {
        "dish_img": "https://www.kindmeal.my/photos/recipe/1000/1000011-19418-m.jpg",
        "dish_name": "Nasi Lemak",
        "owner_name": "MayNg",
        "owner_img": "https://www.kindmeal.my/photos/member/14/14169-m.jpg",
        "time": "45 Mins",
        "servings": "3 Persons",
        "restriction": "- - -",
        "rating": "★ ★ ★ ★ ",
        "vote" : 6,
        "ingredients": [
          "1 1/4 teaspoons ground allspice",
          "2 teaspoons ground nutmeg",
          " 20 spanish saffron threads",
          "1 1/2 teaspoons ground black pepper",
          "1 1/2 teaspoons ground mace",
          "1 teaspoon ground cinnamon",
          "1 1/2 teaspoons ground cardamom",
          "2 teaspoons ground ginger",
          " 2 teaspoons salt",
          "1 teaspoon ground turmeric"
        ],
        "discription": "A basic Nasi Lemak recipe that I try for the best combination. this is the current one that I am using. a wonderful nice taste that makes your saliva gland goes dripping.. yummy!"
      },
      {
        "dish_img": "https://www.kindmeal.my/photos/recipe/1039/1039457-58885-m.jpg",
        "dish_name": "Seaweed Wheat Floss With Vegan Bacon Edamame Fried Rice",
        "owner_name": "YukiAuYong   ",
        "owner_img": "https://www.kindmeal.my/photos/member/13/13040-m.jpg",
        "time": "30 Mins",
        "servings": "2",
        "restriction": "- - -",
        "rating": "★ ★ ★ ★ ",
        "vote" : 6,
        "ingredients": [
          "1 1/4 teaspoons ground allspice",
          "2 teaspoons ground nutmeg",
          " 20 spanish saffron threads",
          "1 1/2 teaspoons ground black pepper",
          "1 1/2 teaspoons ground mace",
          "1 teaspoon ground cinnamon",
          "1 1/2 teaspoons ground cardamom",
          "2 teaspoons ground ginger",
          " 2 teaspoons salt",
          "1 teaspoon ground turmeric"
        ],
        "discription": "Seaweed Wheat Floss with vegan bacon edamame fried rice"
      },
      {
        "dish_img": "https://www.kindmeal.my/photos/recipe/116/116077-17984-m.jpg",
        "dish_name": "Ras-El-Hanout (Moroccan Spice Blend)",
        "owner_name": "KindMealChef",
        "owner_img": "https://www.kindmeal.my/photos/member/0/6-m.jpg",
        "time": "5 Mins",
        "servings": "Depends",
        "restriction": "- - -",
        "rating": "★ ★ ★ ★ ★",
        "vote" : 6,
        "ingredients": [
          "1 1/4 teaspoons ground allspice",
          "2 teaspoons ground nutmeg",
          " 20 spanish saffron threads",
          "1 1/2 teaspoons ground black pepper",
          "1 1/2 teaspoons ground mace",
          "1 teaspoon ground cinnamon",
          "1 1/2 teaspoons ground cardamom",
          "2 teaspoons ground ginger",
          " 2 teaspoons salt",
          "1 teaspoon ground turmeric"
        ],
        "discription": "Using a mortar and pestle or a spice grinder, reduce the ingredients to a fine powder. Sift to remove fibrous elements. Place in a tightly sealed container and store in a cool, dark place, or in the freezer."
      },
      {
          "dish_img": "https://www.kindmeal.my/photos/recipe/1000/1000009-19416-m.jpg",
          "dish_name": "Vegetarian VFC",
          "owner_name": "MayNg",
          "owner_img": "https://www.kindmeal.my/photos/member/14/14169-m.jpg",
          "time": "1 Hr",
          "servings": "Depends",
          "restriction": "- - -",
          "rating": "★ ★ ★ ★ ",
          "vote" : 6,
          "ingredients": [
            "1 1/4 teaspoons ground allspice",
            "2 teaspoons ground nutmeg",
            " 20 spanish saffron threads",
            "1 1/2 teaspoons ground black pepper",
            "1 1/2 teaspoons ground mace",
            "1 teaspoon ground cinnamon",
            "1 1/2 teaspoons ground cardamom",
            "2 teaspoons ground ginger",
            " 2 teaspoons salt",
            "1 teaspoon ground turmeric"
          ],
          "discription": "This is the Vegetarian VFC that I created. Idea sourced from KFC."
        },
        {
          "dish_img": "https://www.kindmeal.my/photos/recipe/108/108760-16499-m.jpg",
          "dish_name": "Pears With Maple, Walnuts And Gorgonzola",
          "owner_name": "KindMealChef",
          "owner_img": "https://www.kindmeal.my/photos/member/14/14169-m.jpg",
          "time": "20 Mins",
          "servings": "Depends",
          "restriction": "- - -",
          "rating": "★ ★ ★ ★ ",
          "vote" : 6,
          "ingredients": [
            "1 1/4 teaspoons ground allspice",
            "2 teaspoons ground nutmeg",
            " 20 spanish saffron threads",
            "1 1/2 teaspoons ground black pepper",
            "1 1/2 teaspoons ground mace",
            "1 teaspoon ground cinnamon",
            "1 1/2 teaspoons ground cardamom",
            "2 teaspoons ground ginger",
            " 2 teaspoons salt",
            "1 teaspoon ground turmeric"
          ],
          "discription": "This is the Vegetarian VFC that I created. Idea sourced from KFC."
        },
        {
          "dish_img": "https://www.kindmeal.my/photos/recipe/108/108760-16499-m.jpg",
          "dish_name": "Hot Caramel Jam Recipe",
          "owner_name": "BurhanBohra",
          "owner_img": "https://www.kindmeal.my/photos/member/14/14169-m.jpg",
          "time": "15 Mins",
          "servings": "1 Cup",
          "restriction": "- - -",
          "rating": "★ ★ ★ ★ ",
          "vote" : 6,
          "ingredients": [
            "1 1/4 teaspoons ground allspice",
            "2 teaspoons ground nutmeg",
            " 20 spanish saffron threads",
            "1 1/2 teaspoons ground black pepper",
            "1 1/2 teaspoons ground mace",
            "1 teaspoon ground cinnamon",
            "1 1/2 teaspoons ground cardamom",
            "2 teaspoons ground ginger",
            " 2 teaspoons salt",
            "1 teaspoon ground turmeric"
          ],
          "discription": "Delicious hot Caramel Jam coffee. Try this delicious flavour of hot caramel coffee recipe. I tried this one to relax and change my mood and its awesome. I gave this unique name to my coffee as i always do with my all recipes.https://burhanrecipe. blogspot.com/2019/11/hot-caram el-coffee-aura.html."
        },
        {
          "dish_img": "https://www.kindmeal.my/photos/recipe/1000/1000011-19418-m.jpg",
          "dish_name": "Nasi Lemak",
          "owner_name": "MayNg",
          "owner_img": "https://www.kindmeal.my/photos/member/14/14169-m.jpg",
          "time": "45 Mins",
          "servings": "3 Persons",
          "restriction": "- - -",
          "rating": "★ ★ ★ ★ ",
          "vote" : 6,
          "ingredients": [
            "1 1/4 teaspoons ground allspice",
            "2 teaspoons ground nutmeg",
            " 20 spanish saffron threads",
            "1 1/2 teaspoons ground black pepper",
            "1 1/2 teaspoons ground mace",
            "1 teaspoon ground cinnamon",
            "1 1/2 teaspoons ground cardamom",
            "2 teaspoons ground ginger",
            " 2 teaspoons salt",
            "1 teaspoon ground turmeric"
          ],
          "discription": "A basic Nasi Lemak recipe that I try for the best combination. this is the current one that I am using. a wonderful nice taste that makes your saliva gland goes dripping.. yummy!"
        },
        {
          "dish_img": "https://www.kindmeal.my/photos/recipe/1039/1039457-58885-m.jpg",
          "dish_name": "Seaweed Wheat Floss With Vegan Bacon Edamame Fried Rice",
          "owner_name": "YukiAuYong   ",
          "owner_img": "https://www.kindmeal.my/photos/member/13/13040-m.jpg",
          "time": "30 Mins",
          "servings": "2",
          "restriction": "- - -",
          "rating": "★ ★ ★ ★ ",
          "vote" : 6,
          "ingredients": [
            "1 1/4 teaspoons ground allspice",
            "2 teaspoons ground nutmeg",
            " 20 spanish saffron threads",
            "1 1/2 teaspoons ground black pepper",
            "1 1/2 teaspoons ground mace",
            "1 teaspoon ground cinnamon",
            "1 1/2 teaspoons ground cardamom",
            "2 teaspoons ground ginger",
            " 2 teaspoons salt",
            "1 teaspoon ground turmeric"
          ],
          "discription": "Seaweed Wheat Floss with vegan bacon edamame fried rice"
        }

  ]

